// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import PrintController from "./print_controller"
application.register("print", PrintController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import DescribeController from "./describe_controller"
application.register("describe", DescribeController)

import FilePickerController from "./file_picker_controller"
application.register("file-picker", FilePickerController)

import ReloadController from "./reload_controller"
application.register("reload", ReloadController)

import NativeCameraController from "./native_camera_controller"
application.register("native-camera", NativeCameraController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import PushController from "./push_controller"
application.register("push", PushController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)
